import axios from 'axios';

// Użyj pełnego URL jeśli jest ustawiony, w przeciwnym razie użyj względnej ścieżki (proxy)
const getBaseURL = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl && envUrl.startsWith('http')) {
    return envUrl; // Pełny URL (np. http://localhost:8081/api)
  }
  return '/api'; // Względna ścieżka (proxy przekieruje)
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000, // 30 sekund timeout dla wszystkich żądań (może być nadpisane dla konkretnych żądań)
});

// Interceptor do dodawania tokenu
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Nie ustawiaj Content-Type dla multipart/form-data - przeglądarka ustawi to automatycznie z boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor do obsługi błędów
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Nie loguj błędów "Request aborted" - to normalne gdy komponent się unmountuje lub żądanie jest anulowane
    const isAborted = error.code === 'ECONNABORTED' || error.message === 'Request aborted' || error.message === 'canceled';
    
    if (!isAborted) {
      // Logowanie błędów dla debugowania (tylko rzeczywiste błędy)
      console.error('API Error:', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        message: error.message,
        response: error.response?.data
      });
    }
    
    if (error.response?.status === 401) {
      // Sprawdź czy to błąd związany z weryfikacją MFA (ale nie podczas logowania)
      const url = error.config?.url || '';
      const errorMessage = error.response?.data?.error || error.response?.data?.message || '';
      const isMfaError = url.includes('/sign/internal') || 
                        url.includes('/sign/external') ||
                        (url.includes('/mfa/') && !url.includes('/login')) ||
                        errorMessage.toLowerCase().includes('nieprawidłowy kod mfa') ||
                        errorMessage.toLowerCase().includes('invalid mfa code') ||
                        (errorMessage.toLowerCase().includes('mfa') && !url.includes('/login'));
      
      if (!isMfaError) {
        // Błąd autoryzacji - token wygasł lub jest nieprawidłowy (ale nie MFA)
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      // Jeśli to błąd MFA, pozwól komponentom obsłużyć błąd (np. pokazać toast)
    } else if (error.response?.status === 403) {
      // Błąd uprawnień - użytkownik nie ma dostępu do zasobu
      // Sprawdź czy komunikat błędu wskazuje na problem z tokenem
      const errorMessage = error.response?.data?.message || error.response?.data?.error || '';
      const tokenRelatedMessages = ['token', 'authentication', 'unauthorized', 'wygasł', 'nieprawidłowy'];
      const isTokenError = tokenRelatedMessages.some(msg => 
        errorMessage.toLowerCase().includes(msg.toLowerCase())
      );
      
      if (isTokenError) {
        // Jeśli błąd jest związany z tokenem, przekieruj do logowania
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      // W przeciwnym razie pozwól komponentom obsłużyć błąd (np. pokazać toast)
    }
    return Promise.reject(error);
  }
);

export default api;
